/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTargetDto } from './searchTargetDto';


export interface SearchBySubjectsRequestDto { 
    /**
     * Array of subjects (targets) to search for
     */
    subjects: Array<SearchTargetDto>;
    /**
     * Filter by document reference statuses
     */
    statuses?: Array<SearchBySubjectsRequestDto.StatusesEnum>;
    /**
     * Filter by document type IDs
     */
    documentTypeIds?: Array<string>;
    /**
     * Number of items to return
     */
    limit?: number;
    /**
     * Number of items to skip
     */
    offset?: number;
    /**
     * Expand document type details
     */
    expandDocumentType?: boolean;
    /**
     * Expand groups that the document type belongs to (requires expandDocumentType=true)
     */
    expandGroups?: boolean;
}
export namespace SearchBySubjectsRequestDto {
    export type StatusesEnum = 'open' | 'closed' | 'on_hold';
    export const StatusesEnum = {
        Open: 'open' as StatusesEnum,
        Closed: 'closed' as StatusesEnum,
        OnHold: 'on_hold' as StatusesEnum
    };
}


